import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { List, Space, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { listApprentices } from "./api";

/**
 * The training records an employee can reach without the Apprenticeship permission: their own
 * and those of the apprentices they train. Empty for everyone else (no request errors shown).
 */
export const useTrainingRecords = enabled => {
  const [records, setRecords] = useState([]);
  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    listApprentices()
      .then(res => active && setRecords(res.data.data))
      .catch(() => active && setRecords([]));
    return () => {
      active = false;
    };
  }, [enabled]);
  return records;
};

/** Links for the profile tab. */
const TrainingRecords = ({ records }) => {
  const { t } = useTranslation("dashboard");
  return (
    <List
      dataSource={records}
      renderItem={a => (
        <List.Item>
          <Space wrap>
            <Link
              to={
                a.relation === "self"
                  ? "/user/berichtsheft"
                  : `/user/berichtsheft/apprentices/${a._id}`
              }
            >
              {a.relation === "self" ? t("My training record") : a.name}
            </Link>
            {a.missing > 0 && <Tag color="error">{t("{{n}} weeks missing", { n: a.missing })}</Tag>}
            {a.toReview > 0 && a.relation !== "self" && (
              <Tag color="processing">{t("{{n}} to review", { n: a.toReview })}</Tag>
            )}
          </Space>
        </List.Item>
      )}
    />
  );
};

export default TrainingRecords;
